module.exports = __webpack_public_path__ + "static/media/hongkong06.88aa1656.jpg";